import { SALE_TYPE } from "../constants";
import { getContractABI, getContractAddress } from "../utils/abiHelper";
import { addressZero, ether, getWeb3IfAvailable, parseError, toNumber, toRealNumber } from "../web3Utils";
import { ContractService } from "./ContractService";


export class OfferModuleService extends ContractService{

    constructor(args = {}) {
        super();
        this.contractType = 'OfferModule'
        this.abi = getContractABI(this.contractType);
        this.addHooks();
    }

    async preHook() {
        this.web3 = await getWeb3IfAvailable()
        this.accounts = await this.web3.eth.getAccounts();
        this.contractAddress = await getContractAddress(this.contractType);
        this.nftAddress = await getContractAddress('MonstersClanNft');
        this.contractInstance = new this.web3.eth.Contract(
            this.abi,
            this.contractAddress
        );
    }
    
    async getMarketItem(
        tokenId
    ) {
        try{
            console.log('tokenId', tokenId)
            const marketItem = await this.contractInstance
                .methods
                .getMarketItem(
                    this.nftAddress,
                    tokenId
                ).call();
         
            return {
                ...marketItem,
                saleType: SALE_TYPE.NONE,
                itemOffersLength: toRealNumber(marketItem.itemOffersLength),
            }
        } catch(err) {
            throw parseError(err);
        }
    }

    async getOfferByIndex(
        nftAddress,
        tokenId,
        index
    ) {
        try{
            const offerItem = await this.contractInstance
                .methods
                .getOfferByIndex(
                    nftAddress || this.nftAddress,
                    tokenId,
                    index
                ).call();
         
            return {
                offerer: offerItem.offerer,
                value: toNumber(offerItem.value),
                timestamp: toRealNumber(offerItem.timestamp),
                expireOffset: toRealNumber(offerItem.expireOffset),
            }
        } catch(err) {
            throw parseError(err);
        }
    }

    async placeOffer({
        tokenId,
        value,
        expireOffset = 60 * 60 * 24 * 7
    }) {
        console.log('tokenId', tokenId, this.nftAddress)
        try {
            const gasPrice = await this.web3.eth.getGasPrice();

            let args = [
                this.nftAddress,
                tokenId,
                ether(value),
                expireOffset
            ], options = {
                gasPrice,
                from: this.accounts[0]
            };

            const estimatedGas = await this.contractInstance
                .methods
                .placeOffer( ...args)
                .estimateGas(options);
             
            options['gas'] = estimatedGas + 5000;
            await this.contractInstance
                .methods
                .placeOffer( ...args )
                .send(options);
        } catch(err) {
            throw parseError(err);
        }
        return 'Offer placed successfully!';
    }

    async removeOffer({
        tokenId,
        index
    }) {
        console.log('tokenId', tokenId, this.nftAddress)
        try {
            const gasPrice = await this.web3.eth.getGasPrice();

            let args = [
                this.nftAddress,
                tokenId,
                index
            ], options = {
                gasPrice,
                from: this.accounts[0]
            };

            const estimatedGas = await this.contractInstance
                .methods
                .removeOffer( ...args)
                .estimateGas(options);
             
            options['gas'] = estimatedGas + 5000;
            await this.contractInstance
                .methods
                .removeOffer( ...args )
                .send(options);
        } catch(err) {
            throw parseError(err);
        }
        return 'Offer removed successfully!';
    }

    async acceptOffer({
        tokenId,
        index
    }) {
        console.log('tokenId', tokenId, this.nftAddress)
        try {
            const gasPrice = await this.web3.eth.getGasPrice();

            let args = [
                this.nftAddress,
                tokenId,
                index
            ], options = {
                gasPrice,
                from: this.accounts[0]
            };

            const estimatedGas = await this.contractInstance
                .methods
                .acceptOffer( ...args)
                .estimateGas(options);
             
            options['gas'] = estimatedGas + 5000;
            await this.contractInstance
                .methods
                .acceptOffer( ...args )
                .send(options);
        } catch(err) {
            throw parseError(err);
        }
        return 'Offer accepted successfully!';
    }

    async getOffers({
        tokenId,
        limit = 10,
        skip = 0
    }) {

        try {

            const offers = await Promise.allSettled(
                Array(limit)
                .fill(0)
                .map(( _, index) => {
                    return this.getOfferByIndex(
                        this.nftAddress,
                        tokenId,
                        skip + index 
                    )
                })
            );
            return [...offers.values()]
                .filter((resp) => resp.value && resp.value.offerer !==  addressZero())
                .map((resp) => resp.value)
         } catch(err) {
             console.log('Caught error while fetching NFTs', err)
            throw parseError(err);
        }
    }

}